import { Injectable } from '@angular/core';
import { ClimateCortexModelService } from './ccc.model.service';
import { IStock } from '../../model/stock';
import { IGlobalExternality } from '../../model/global-externality';
import { ClimateCortexModelInitializerService } from '../../../climate-cortex-model-initializer.service';
import { IVariable } from '../../model/variable';
import { IResource } from '../../model/resource';
import { ICarbonCausalChain } from '../../model/carbon-causal-chain';
import { ITransitionElement } from '../../model/transition-element';

@Injectable({ providedIn: 'root', useClass: ClimateCortexModelService, deps: [ClimateCortexModelInitializerService] })
export abstract class IClimateCortexModelService {
  abstract get transitionElements(): {
    [key: string]: ITransitionElement;
  };
  abstract get carbonCausalChains(): {
    [key: string]: ICarbonCausalChain;
  };
  abstract get resources(): {
    [key: string]: IResource;
  };
  abstract get variables(): {
    [key: string]: IVariable;
  };
  abstract get stocks(): {
    [key: string]: IStock;
  };
  abstract get globalExternalities(): {
    [key: string]: IGlobalExternality;
  };
}
